import React, { useEffect, useState } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPostulacion } from "../components/BannerPostulacion";
import { Footer } from "../../../components/Landing/Footer";
// hooks
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { useSeleccionarCategoria } from "../../../hooks/useSeleccionarCategoria";
// styled component
import { Select, Button, message } from "antd";
import "../Usuario.style.scss";
import { RootState } from "../../../redux/reducers";
import { useSelector } from "react-redux";
import ModalWarning from "../../../utils/Alerts/ModalWarning";
import { useNavigate } from "react-router-dom";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { useEncrypt } from "../../../hooks/useEncrypt";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";

export const SeleccionarCategoria = () => {

  const navigate = useNavigate();
  const { convocatoriaPersitente: convocatoria, getConvocatoriaPersistente } =
    UseVerConvocatorias();
  const [_data, set_data] = useState<any>({});
  const { decrypt, } = useEncrypt();
  const [disabled, setDisabled] = useState(false);

  const {
    categoria,
    cambioCategorias,
    guardarCategoriaPostulacion,
    setCategoria,
    setOpenModalError,
    openModalError,
    onCategorias,
    onAceptar,
    loading,
  } = useSeleccionarCategoria();

  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );

  const consultarPostulacion = async () => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));
    const idConvocatoriaPostulacion = decrypt(localStorage.getItem('idConvocatoriaPostulacion'));

    const dataConvocatoria = await apiConvocatorias.getConvocatoriaById(idConvocatoriaPostulacion);
    const dataPostulacion = await apiParticipantes.consultarPostulacion(id_postulacion);

    if (dataPostulacion && dataPostulacion.data && dataPostulacion.data.categoria_linea_convocatoria && dataPostulacion.data.categoria_linea_convocatoria !== null) {
      const categoriaActual = dataConvocatoria.data.categoria_linea_convocatoria.filter((x: any) => x.value === dataPostulacion.data.categoria_linea_convocatoria);
      cambioCategorias(String(categoriaActual[0].text));
      setDisabled(true);
    } else {
      return;
    }
  }

  useEffect(() => {
    setCategoria(null);
    getConvocatoriaPersistente();
    consultarPostulacion();
    if (datos_postulacion.categoriaPropuesta) {
      setCategoria(datos_postulacion.categoriaPropuesta[0].value);
    }
  }, []);

  return (
    <div>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <BannerPostulacion convocatorias={convocatoria} />
        <div className="container-fluid2">
          <div className="pt-4 row">
            <div className="no-margin col-12 font-family-Montserrat-Regular font-size-18px">
              <span className="font-family-Montserrat-SemiBold">
                ¡GENIAL! Estás a punto de postularte en la convocatoria.
              </span>{" "}
              ¡Por favor completa los siguientes datos. Recuerda que todos los
              campos son obligatorios!
            </div>
          </div>

          <div className="row">
            <div className="row pe-0 mt-4">
              <div className="col-2 ms-2 text-center font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion">
                2
              </div>
              <div className="col ps-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
                Selecciona a la categoría que te vas a postular
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12">
              <Select
                style={{ width: "100%" }}
                placeholder="Seleccionar..."
                value={categoria}
                onChange={cambioCategorias}
              >
                {convocatoria.categoria_linea_convocatoria.map(
                  ({ value, text }: any) => (
                    <Select.Option key={value} value={value}>
                      {text}
                    </Select.Option>
                  )
                )}
              </Select>
            </div>
          </div>
        </div>
        <div className="container-fluid2">
          <div className="justify-content-flex-end">
            <Button
              style={{ marginRight: "1%" }}
              type="link"
              className="button-blanco-radius font-size-12px"
              onClick={async () => {
                const data = await guardarCategoriaPostulacion(convocatoria, true);
                set_data(data);
              }}
            >
              Guardar y salir
            </Button>
            <Button
              style={{ marginRight: "1%" }}
              type="link"
              className="button-blanco-radius font-size-12px"
              onClick={() => navigate('/usuario/Seleccionarrol')}
            >
              Atrás
            </Button>
            <Button
              type="link"
              className="button-azul-radius font-size-12px"
              onClick={async () => {
                if (disabled) {
                  return navigate('/usuario/Documentosadministrativos')
                } else {
                  const data = await guardarCategoriaPostulacion(convocatoria);
                  set_data(data);
                }
              }}
              disabled={loading}
            >
              Continuar
              {loading && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                />
              )}
            </Button>
          </div>
        </div>
      </div>
      <Footer />
      <ModalWarning
        visualizar={openModalError}
        setVisualizar={setOpenModalError}
        onAceptar={onAceptar}
        onCategorias={onCategorias}
        description={_data ? (("mensaje" in _data) ? _data.mensaje : ("message" in _data) ? _data.message : "") : ""}
        subdescription='Postúlate a otra categoría o si no has completado la postulación, intenta editarla desde la sección "Mis Proyectos" dando clic en la opción editar para retomarla'
      />
    </div>
  );
};
